import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { green } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Snackbar, SnackbarContent } from '@mui/material';

/*
 * Call with something like
 * <CrmSnackbar
 *   show={T/F}
 *   message={<some string>}
 *   closeFunc={<some callback function>}
 */

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    snackbarSuccess: {
      backgroundColor: green[600],
    },
    snackbarMessage: {
      display: 'flex',
      alignItems: 'center',
    },
    snackbarIcon: {
      marginRight: theme.spacing(1),
    },
  })
);

export default function CrmSnackbar({ show, message, closeFunc }) {
  const classes = useStyles();

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={show}
        autoHideDuration={6000}
        onClose={closeFunc}
      >
        <SnackbarContent
          className={classes.snackbarSuccess}
          message={
            <span className={classes.snackbarMessage}>
              <CheckCircleIcon className={classes.snackbarIcon} />
              {message}
            </span>
          }
          action={[
            <IconButton key="close" aria-label="close" color="inherit" onClick={closeFunc} size="large">
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  );
}
